export default __webpack_public_path__ + "static/media/BetterLuckNextTime-Mastered-Final.8bab4535.mp3";